import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function Timestamp({data}) {
    return (
        <div className="time_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="m-auto">
                        <h5 className="episode_name text-start">
                            Timestamps
                        </h5>
                        <ul className="timestamp">
                            <li><span>00:00</span> Introduction of the guest</li>
                            <li><span>2:04</span> About Nerdio</li>
                            <li><span>5:58</span> One thing that you didn’t expect</li>
                            <li><span>8:01</span> Debunking the biggest myths related to the cloud</li>
                            <li><span>12:02</span>23 Years at Microsoft</li>
                            <li><span>14:42</span> Biggest career challenge</li>
                            <li><span>17:40</span> Advice for fresh graduates</li>
                            <li><span>19:40</span> Productivity hack for entrepreneurs</li>
                            <li><span>22:38</span> Does Web 3.0 changes anything in the cloud?</li>
                            <li><span>25:06</span> One thing you’d like to change about Nerdio</li>
                            <li><span>26:44</span>Importance of Culture</li>
                            <li><span>27:58</span> Why networking events are crucial?</li>
                            <li><span>30:29</span> Effective methods for networking</li>
                            <li><span>33:40</span> The need to educate clients & partners</li>
                        </ul>
                    </Col>
                </Row>

            </Container>
        </div>
    );
}

export default Timestamp;